import axios from 'axios';
import { SEASON_ERROR_MESSAGES } from '../../corelogic/domain/errors/gateway.errorMessages/season.error.messages';
import { SeasonError } from '../../corelogic/domain/errors/season.error';
import { Season } from '../../corelogic/domain/models/season.model';
import { SeasonGateway } from '../../corelogic/domain/ports/season.port';
import { getSecureRequestHeaders } from '../../corelogic/domain/utils/securityHeaders.utils';
import { handleAuthError } from './auth.error.handler';

export class ApiSeasonGateway implements SeasonGateway {
  private apiEndpoint: string;

  private handleSeasonError(error: unknown): never {
    //check if the error is auth related
    if (
      axios.isAxiosError(error) &&
      error.response?.data?.error?.includes('token')
    ) {
      throw handleAuthError(error);
    }

    //if not, throw a season error
    throw new SeasonError(SEASON_ERROR_MESSAGES.SERVER_ERROR);
  }

  constructor(apiEndpoint: string) {
    this.apiEndpoint = apiEndpoint;
  }

  async retrieveSeasons(token: string): Promise<Season[]> {
    try {
      const response = await axios.get<{ seasons: Season[] }>(
        `${this.apiEndpoint}/seasons`,
        {
          headers: {
            ...getSecureRequestHeaders(token),
          },
        },
      );
      return response.data.seasons;
    } catch (error) {
      throw this.handleSeasonError(error);
    }
  }
}
